export default "__VITE_ASSET__DPvhzc_P__"